import {
  AssessmentOutlined as AssessmentOutlinedIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  InsightsOutlined as InsightsOutlinedIcon,
  Inventory2Outlined as Inventory2OutlinedIcon,
  MenuBookOutlined as MenuBookOutlinedIcon,
  SwapHorizOutlined as SwapHorizOutlinedIcon,
  TimelineOutlined as TimelineOutlinedIcon,
  UploadFileOutlined as UploadFileOutlinedIcon,
  WarehouseOutlined as WarehouseOutlinedIcon
} from '@mui/icons-material'

export const inventoryHubCards = {
  warehouses: {
    title: 'Bodegas',
    description: 'Configura bodegas y ubicaciones de operación.',
    infoText: 'Crea, desactiva y administra las bodegas disponibles para operar inventario.',
    icon: WarehouseOutlinedIcon,
    target: 'warehouses'
  },
  items: {
    title: 'Catálogo productos o servicio',
    description: 'Administra productos, insumos y servicios del catálogo.',
    infoText: 'Define SKU, unidad, tipo, precio, control de inventario, receta y estado de cada registro.',
    icon: Inventory2OutlinedIcon,
    target: 'items'
  },
  operations: {
    title: 'Mantención de inventario',
    description: 'Trabaja movimientos manuales y transferencias.',
    infoText: 'Registra entradas, salidas, ajustes y transferencias entre bodegas.',
    icon: SwapHorizOutlinedIcon,
    target: 'operations'
  },
  salesNote: {
    title: 'Nota de venta',
    description: 'Arma una nota de venta interna con preview tipo factura.',
    infoText:
      'Documento interno y visual. Permite completar cliente, detalle e IVA sin emitir al SII.',
    icon: DescriptionOutlinedIcon,
    target: 'sales-note',
    badge: 'Nuevo',
    tone: 'amber'
  },
  recipes: {
    title: 'Recetas',
    description: 'Configura recetas para productos compuestos.',
    infoText: 'Relaciona componentes y rendimiento para productos armados o BOM.',
    icon: MenuBookOutlinedIcon,
    target: 'recipes'
  },
  uploads: {
    title: 'Carga Excel',
    description: 'Importa catálogo y stock inicial.',
    infoText: 'Importa items o stock inicial desde planillas Excel.',
    icon: UploadFileOutlinedIcon,
    target: 'uploads'
  },
  stock: {
    title: 'Inventario actualizado',
    description: 'Consulta existencias por item y bodega.',
    infoText: 'Muestra existencias actualizadas por item y por bodega.',
    icon: AssessmentOutlinedIcon,
    target: 'stock'
  },
  movements: {
    title: 'Ajustes de inventario',
    description: 'Revisa el historial operativo.',
    infoText: 'Permite revisar la trazabilidad de ajustes, ingresos, salidas y transferencias.',
    icon: TimelineOutlinedIcon,
    target: 'movements'
  },
  reports: {
    title: 'Informes',
    description: 'Pronto tendrás reportes consolidados de inventario.',
    infoText: 'Seccion bloqueada para futuros informes operativos y analiticos del modulo.',
    icon: InsightsOutlinedIcon,
    badge: 'Bloqueado'
  }
}

export const inventoryHubGroups = [
  {
    key: 'create',
    title: 'Crear',
    description: 'Altas, mantención y carga operativa.',
    cards: ['warehouses', 'items', 'operations', 'recipes', 'uploads', 'salesNote']
  },
  {
    key: 'explore',
    title: 'Explorar',
    description: 'Consulta estado e historial.',
    cards: ['stock', 'movements', 'reports']
  }
]
